import { decodePosterStudioMessage } from '@euler/model/poster-studio';
import { useEffect, useRef } from 'react';
import { PosterStudioFrameProps } from './PosterStudioFrame.shared';

/**
 * The studio in an iframe. Messages are heard only from the studio's origin and
 * from this frame, and sent only to that origin.
 */
export function PosterStudioFrame({
  url,
  origin,
  toStudio$,
  onEvent,
}: PosterStudioFrameProps) {
  const frame = useRef<HTMLIFrameElement | null>(null);
  const latestOnEvent = useRef(onEvent);
  latestOnEvent.current = onEvent;

  useEffect(() => {
    const subscription = toStudio$.subscribe(
      envelope => frame.current?.contentWindow?.postMessage(envelope, origin),
    );
    return () => subscription.unsubscribe();
  }, [toStudio$, origin]);

  useEffect(() => {
    const listener = (message: MessageEvent) => {
      if (message.origin !== origin) return;
      if (message.source !== frame.current?.contentWindow) return;
      const event = decodePosterStudioMessage(message.data);
      if (event) latestOnEvent.current(event);
    };
    window.addEventListener('message', listener);
    return () => window.removeEventListener('message', listener);
  }, [origin]);

  return (
    <iframe
      ref={frame}
      src={url}
      title="朋友圈海报"
      allow="clipboard-write"
      style={{ border: 0, width: '100%', height: '100%', display: 'block' }}
    />
  );
}
